import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { CONTINUE_WITH_SAML_SSO_BTN } from '~/constants/testIDs';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';

type ContinueWithSSOButtonProps = ComponentProps<'button'>;

export const ContinueWithSAMLSSOButton = memo(({ className, ...rest }: ContinueWithSSOButtonProps) => {
  const { maintenanceModeJson } = useFeatureFlags();

  // biome-ignore lint/suspicious/noUnnecessaryConditions: maintenanceMessage may be absent while JSON is always defined from the hook
  if (maintenanceModeJson?.maintenanceMessage) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center">
      <button
        data-testid={CONTINUE_WITH_SAML_SSO_BTN}
        className={cn(
          'font-medium ads:text-metadata text-14 text-gray-10 underline ads:hover:text-primary hover:text-gray-12',
          className,
        )}
        {...rest}
      >
        Continue with SAML SSO
      </button>
    </div>
  );
});

ContinueWithSAMLSSOButton.displayName = 'ContinueWithSSOButton';
